import { render, staticRenderFns } from "./AddAttribute.vue?vue&type=template&id=9779e2ae&scoped=true"
import script from "./AddAttribute.vue?vue&type=script&lang=js"
export * from "./AddAttribute.vue?vue&type=script&lang=js"
import style0 from "./AddAttribute.vue?vue&type=style&index=0&id=9779e2ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9779e2ae",
  null
  
)

export default component.exports